import React from "react";
import { Link } from "react-router-dom";
import {
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaLink,
}  from "react-icons/fa";
/* import { FaWhatsapp } from "react-icons/fa";*/

const PHONE_TEL = "+919480085001";
const PHONE = "+91 94800 85001";
const EMAIL = "gitiharihara@gmail.com";
/*const WHATSAPP = "919480085001";*/

const Footer = () => (
  <footer className="mt-16 bg-gray-900 text-white">
    <div className="mx-auto max-w-7xl px-4 py-14 md:px-8">
      <div className="grid grid-cols-1 gap-8 md:grid-cols-4">
        <section className="space-y-3">
          <p className="text-lg font-semibold">Government ITI Harihara</p>
          <p className="text-sm text-gray-300">
            Premium, practical skill training with government approved trades and placement support.
          </p>
          <div className="inline-flex h-1 w-24 rounded-full bg-gradient-to-r from-pink-400 to-yellow-300" />
        </section>

        <section className="space-y-4">
          <p className="text-sm font-semibold uppercase tracking-widest text-gray-200">Contact Info</p>
          <div className="space-y-3 text-sm text-gray-300">
            <p className="flex items-start gap-3">
              <FaMapMarkerAlt className="mt-0.5 shrink-0 text-pink-400" aria-hidden />
              <span>
                Govt ITI APMC Yard Harihar, Shivamogga Road, Harihar (T), Davanagere (D), Karnataka 577601
              </span>
            </p>
            <a
              href={`tel:${PHONE_TEL}`}
              className="flex items-center gap-3 text-gray-300 transition hover:text-pink-400"
            >
              <FaPhoneAlt className="shrink-0 text-yellow-300" aria-hidden />
              {PHONE}
            </a>
            <a
              href={`mailto:${EMAIL}`}
              className="flex items-center gap-3 text-gray-300 transition hover:text-pink-400"
            >
              <FaEnvelope className="shrink-0 text-yellow-300" aria-hidden />
              {EMAIL}
            </a>
          </div>
        </section>

        <section className="space-y-4">
          <p className="text-sm font-semibold uppercase tracking-widest text-gray-200">Quick Links</p>
          <ul className="space-y-2 text-sm">
            {[
              { label: "Home", to: "/" },
              { label: "About", to: { pathname: "/", hash: "about" } },
              { label: "Trades", to: "/trades" },
              { label: "Faculties", to: "/faculties" },
              { label: "Gallery", to: "/gallery" },
              { label: "Admissions", to: { pathname: "/", hash: "admissions" } },
              { label: "Student Success Stories", to: { pathname: "/", hash: "student-success-stories" } },
              { label: "Contact", to: "/contact" },
            ].map((l) => (
              <li key={l.label}>
                <Link
                  to={l.to}
                  className="inline-flex items-center gap-2 text-gray-300 transition hover:text-pink-400"
                >
                  <FaLink className="text-[10px] opacity-70" aria-hidden />
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </section>
      </div>

      <div className="mt-10 border-t border-white/10 pt-6 text-center text-sm text-gray-300">
        © 2026 Government ITI Harihara | Designed & Developed by{" "}
        <span
          className="font-semibold tracking-wide"
          style={{
            background: "linear-gradient(to right, #f472b6, #facc15)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            textShadow: "0 0 8px rgba(236, 72, 153, 0.18)",
          }}
        >
          Ajay T
        </span>
      </div>
    </div>
  </footer>
);

export default Footer;
